import React from 'react';
import { Avatar } from '@mui/material';

import './_style.scss';

const stringToColor = (string: string) => {
  let hash = 0;
  let i;
  /* eslint-disable no-bitwise */
  for (i = 0; i < string?.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value?.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */
  return color;
};

const stringAvatar = (name: string) => {
  return {
    sx: { bgcolor: stringToColor(name) },
    children: name && `${name[0] !== '@' ? name[0] : name[1]}`,
  };
};

type Props = {
  src: string | undefined;
  alt?: string | undefined;
  size?: number;
  style?: any;
  onClick?: () => void;
};

export default function AvatarComponent({ src, alt = '', size = 30, style, onClick }: Props) {
  if (src) {
    return <Avatar sx={{ width: size, height: size, ...style }} src={src} alt={alt} onClick={onClick} />;
  } else {
    return (
      <Avatar
        style={{
          justifyContent: 'center',
          width: size,
          height: size,
          fontSize: size / 1.85,
          fontWeight: 500,
          ...style,
        }}
        {...stringAvatar(alt)}
        alt={alt}
        onClick={onClick}
      />
    );
  }
}

export const AvatarTeamComponent = ({
  src = '',
  first_name = '',
  last_name = '',
  active = false,
  size = 16,
  className = '',
}) => {
  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? `${text.substring(0, maxLength)}…` : text;
  };

  return (
    <div className={`avatar-component__container center ${className}`}>
      <div className="avatar-component__inner-container">
        <AvatarComponent
          src={src}
          alt={`${first_name.toUpperCase()} ${last_name.toUpperCase()}`}
          size={size}
          style={{ flexShrink: 0 }}
        />
        <div className="avatar-component__text-container">
          <p
            className={`avatar-component__name ${active ? 'avatar-component__name--active' : 'avatar-component__name--inactive'}`}>
            {truncateText(`${first_name.toUpperCase()} ${last_name.toUpperCase()}`, active ? 11 : 14)}
          </p>
        </div>
      </div>
    </div>
  );
};
